import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getCategoriaHomeByCategoriaId,
  getCategoriaHomeByEtiquetaId,
  getCategoriaHomeByFechaId,
  updateCategoriasHome,
  insertCategoriaHome,
  deleteCategoriaHome,
  getCategoriaHomeAll,
  getCategoriaHomeSelected,
  updateSelectedCategoriaHome,
  getCategoriaEspecialSelected,
  updateSelectedCategoriaEspecial
} from 'services/configuracionPortal'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_CATEGORIA_HOME_BY_CATEGORIA_ID(action) {
  try {
    const categoriaHomeData = yield call(getCategoriaHomeByCategoriaId, action.payload)
    if (categoriaHomeData.ok) {
      yield put({
        type: actions.CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_SUCCEEDED,
        payload: categoriaHomeData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categorias Home')
      put({
        type: actions.CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIA_HOME_BY_ETIQUETA_ID(action) {
  try {
    const categoriaHomeData = yield call(getCategoriaHomeByEtiquetaId, action.payload)
    if (categoriaHomeData.ok) {
      yield put({
        type: actions.CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_SUCCEEDED,
        payload: categoriaHomeData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categorias Home')
      put({
        type: actions.CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIA_HOME_BY_FECHA_ID(action) {
  try {
    const categoriaHomeData = yield call(getCategoriaHomeByFechaId, action.payload)
    if (categoriaHomeData.ok) {
      yield put({
        type: actions.CATEGORIA_HOME_BY_FECHA_ID_LOAD_SUCCEEDED,
        payload: categoriaHomeData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categorias Home')
      put({
        type: actions.CATEGORIA_HOME_BY_FECHA_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIA_HOME_BY_FECHA_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_CATEGORIA_HOME(action) {
  try {
    const categoriaHomeObj = yield call(insertCategoriaHome, action.payload)
    if (categoriaHomeObj.ok) {
      putMessage(messageType.SUCCESS, 'Categoría Home creada correctamente')
      yield put({
        type: actions.CATEGORIA_HOME_INSERT_SUCCEEDED,
        payload: categoriaHomeObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Categoría Home')
      yield put({
        type: actions.CATEGORIA_HOME_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Categoría Home')
    yield all([
      put({
        type: actions.CATEGORIA_HOME_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CATEGORIAS_HOME(action) {
  try {
    const categoriaHomeObj = yield call(updateCategoriasHome, action.payload)
    if (categoriaHomeObj.ok) {
      putMessage(messageType.SUCCESS, 'Categoría Home modificada correctamente')
      if (action.tipoConfiguracion === 1) {
        yield put({
          type: actions.CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_REQUESTED,
          payload: action.idTipoConfiguracion,
        })
      } else if (action.tipoConfiguracion === 2) {
        yield put({
          type: actions.CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_REQUESTED,
          payload: action.idTipoConfiguracion,
        })
      } else if (action.tipoConfiguracion === 3) {
        yield put({
          type: actions.CATEGORIA_HOME_BY_FECHA_ID_LOAD_REQUESTED,
          payload: action.idTipoConfiguracion,
        })
      }
      yield put({
        type: actions.CATEGORIA_HOME_UPDATE_SUCCEEDED,
        payload: categoriaHomeObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Categoría Home')
      yield put({
        type: actions.CATEGORIA_HOME_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Categoría Home')
    yield all([
      put({
        type: actions.CATEGORIA_HOME_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CATEGORIA_HOME_SELECTED(action) {
  try {
    const categoriaHomeObj = yield call(updateSelectedCategoriaHome, action.payload)
    if (categoriaHomeObj.ok) {
      putMessage(messageType.SUCCESS, 'Categorías Home seleccionadas, modificadas correctamente')
      yield put({
        type: actions.CATEGORIA_HOME_UPDATE_SELECTED_SUCCEEDED,
        payload: categoriaHomeObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Categorías Home seleccionadas')
      yield put({
        type: actions.CATEGORIA_HOME_UPDATE_SELECTED_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Categorías Home seleccionadas')
    yield all([
      put({
        type: actions.CATEGORIA_HOME_UPDATE_SELECTED_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CATEGORIA_ESPECIAL_SELECTED(action) {
  try {
    const categoriaEspecialObj = yield call(updateSelectedCategoriaEspecial, action.payload)
    if (categoriaEspecialObj.ok) {
      putMessage(messageType.SUCCESS, 'Categorías Especial seleccionadas, modificadas correctamente')
      yield put({
        type: actions.CATEGORIA_ESPECIAL_UPDATE_SELECTED_SUCCEEDED,
        payload: categoriaEspecialObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Categorías Especial seleccionadas')
      yield put({
        type: actions.CATEGORIA_ESPECIAL_UPDATE_SELECTED_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Categorías Especial seleccionadas')
    yield all([
      put({
        type: actions.CATEGORIA_ESPECIAL_UPDATE_SELECTED_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_CATEGORIA_HOME(action) {
  try {
    const categoriaHomeResult = yield call(deleteCategoriaHome, action.payload)
    if (categoriaHomeResult.ok) {
      putMessage(messageType.SUCCESS, 'Categoría Home eliminada correctamente')
      yield put({
        type: actions.CATEGORIA_HOME_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Categoría Home')
      yield put({
        type: actions.CATEGORIA_HOME_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Categoría Home')
    yield all([
      put({
        type: actions.CATEGORIA_HOME_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIA_ALL(action) {
  try {
    const categoriaHomeData = yield call(getCategoriaHomeAll, action.payload)
    if (categoriaHomeData.ok) {
      yield put({
        type: actions.CATEGORIA_HOME_ALL_LOAD_SUCCEEDED,
        payload: categoriaHomeData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categorias Home')
      put({
        type: actions.CATEGORIA_HOME_ALL_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIA_HOME_ALL_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIA_HOME_SELECTED(action) {
  try {
    const categoriaHomeData = yield call(getCategoriaHomeSelected, action.payload)
    if (categoriaHomeData.ok) {
      yield put({
        type: actions.CATEGORIA_HOME_SELECTED_LOAD_SUCCEEDED,
        payload: categoriaHomeData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categorias Home seleccionadas')
      put({
        type: actions.CATEGORIA_HOME_SELECTED_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIA_HOME_SELECTED_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIA_ESPECIAL_SELECTED(action) {
  try {
    const categoriaEspecialData = yield call(getCategoriaEspecialSelected, action.payload)
    if (categoriaEspecialData.ok) {
      yield put({
        type: actions.CATEGORIA_ESPECIAL_SELECTED_LOAD_SUCCEEDED,
        payload: categoriaEspecialData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categorias Especiales seleccionadas')
      put({
        type: actions.CATEGORIA_ESPECIAL_SELECTED_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIA_ESPECIAL_SELECTED_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(
      actions.CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_REQUESTED,
      GET_CATEGORIA_HOME_BY_CATEGORIA_ID,
    ),
    takeEvery(
      actions.CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_REQUESTED,
      GET_CATEGORIA_HOME_BY_ETIQUETA_ID,
    ),
    takeEvery(actions.CATEGORIA_HOME_BY_FECHA_ID_LOAD_REQUESTED, GET_CATEGORIA_HOME_BY_FECHA_ID),
    takeEvery(actions.CATEGORIA_HOME_INSERT_REQUESTED, INSERT_CATEGORIA_HOME),
    takeEvery(actions.CATEGORIA_HOME_UPDATE_REQUESTED, UPDATE_CATEGORIAS_HOME),
    takeEvery(actions.CATEGORIA_HOME_DELETE_REQUESTED, DELETE_CATEGORIA_HOME),
    takeEvery(actions.CATEGORIA_HOME_ALL_LOAD_REQUESTED, GET_CATEGORIA_ALL),
    takeEvery(actions.CATEGORIA_HOME_SELECTED_LOAD_REQUESTED, GET_CATEGORIA_HOME_SELECTED),
    takeEvery(actions.CATEGORIA_HOME_UPDATE_SELECTED_REQUESTED, UPDATE_CATEGORIA_HOME_SELECTED),
    takeEvery(actions.CATEGORIA_ESPECIAL_SELECTED_LOAD_REQUESTED, GET_CATEGORIA_ESPECIAL_SELECTED),
    takeEvery(actions.CATEGORIA_ESPECIAL_UPDATE_SELECTED_REQUESTED, UPDATE_CATEGORIA_ESPECIAL_SELECTED),
  ])
}
